import { ContentPaste } from "@mui/icons-material";
import { Button, IconButton, TableCell, Tooltip } from "@mui/material";
import { useSessionContext } from "../../../../../contexts/SessionContext";
import { useEhrRecordsMobileLayout } from "../../../context/EhrRecordsLayoutContext";
import {
  EhrMobileActionStack,
  ehrMobileActionBtnSx,
} from "../../mobile/EhrMobileActionStack";

export function ProblemsActions({
  row,
  openVisualizer,
  verifyVisualizer,
}: any) {
  const { access } = useSessionContext();
  const isEhrMobileCard = useEhrRecordsMobileLayout();

  const resolveEncounterId = () => {
    if (row?.isCustom && row?.encounterRef) {
      return row.encounterRef.split("/")[1];
    }
    return row.encounterId;
  };

  const canViewEncounter =
    verifyVisualizer && access?.type === "professional";

  const handleOpenEncounter = () => {
    openVisualizer(resolveEncounterId());
  };

  if (isEhrMobileCard) {
    if (!canViewEncounter) return null;
    return (
      <EhrMobileActionStack>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          startIcon={<ContentPaste />}
          sx={ehrMobileActionBtnSx}
          onClick={handleOpenEncounter}
        >
          Visualizar atendimento
        </Button>
      </EhrMobileActionStack>
    );
  }

  return (
    <TableCell align="center">
      {canViewEncounter ? (
        <Tooltip title="Visualizar atendimento">
          <IconButton onClick={handleOpenEncounter}>
            <ContentPaste />
          </IconButton>
        </Tooltip>
      ) : null}
    </TableCell>
  );
}
